<template>
  <v-menu
    ref="menu"
    :close-on-content-click="false"
    max-height="300px"
    class="scroll-x overflow-x-auto"
  >
    <!-- :nudge-width="200" offset-x-->
    <template #activator="{ on }">
      <v-text-field
        v-bind="$attrs"
        :value="categoryName"
        :loading="$store.state.categories.loading"
        readonly
        v-on="on"
        @click="init"
        @click:clear="$emit('input', '')"
      />
    </template>

    <v-card>
      <v-card-text class="pa-0">
        <div v-if="loading" class="text-xs-center pa-3">
          <v-progress-circular :size="50" color="primary" indeterminate />
        </div>
        <v-treeview
          v-else
          :items="categoryTree"
          :load-children="fetchChildren"
          item-text="name"
          open-on-click
          :open.sync="open"
          :active="active"
          activatable
          active-class="primary--text"
          transition
        >
          <template slot="label" slot-scope="{ item, active }">
            {{ item.name }}
            <v-btn
              :id="item.id"
              :ref="item.id"
              color="primary"
              :disabled="active"
              class="ma-0"
              :loading="loadingChildren === item.id"
              small
              flat
              @click="submit(item.id, item.name)"
            >
              {{ !active ? $t('action.buttons.select') : '' }}
            </v-btn>
          </template>
        </v-treeview>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
import { debounce } from 'debounce'
import { mapActions } from 'vuex'
import { apiAxios } from '@/helpers'

export default {
  name: 'CategoryMenu',
  props: {
    objects: { type: Array },
  },
  data() {
    return {
      categoryTree: [],
      open: [],
      active: [],
      categorySelectList: [],
      loading: false,
      loadingChildren: '',
      categoryName: '',
      categoryDuration: 90,
    }
  },
  computed: {
    value: {
      get() {
        return this.$attrs.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },

  watch: {
    categoryDuration(val) {
      this.$emit('duration', val)
    },
    '$attrs.value': {
      handler: async function (val) {
        if (val) {
          const { data } = await apiAxios.post('categories/select', {
            _id: val,
          })

          const category = data.data.category[0]

          if (category) {
            this.categoryDuration = category.matchesDuration || 90

            const categories = [category.text]
            if (category.parent1) {
              categories.push(category.parent1)
              if (category.parent2) categories.push(category.parent2)
            }
            this.categoryName = categories.reverse().join(' - ')
          }
        } else {
          this.categoryDuration = 90

          this.categoryName = ''
        }
      },
      deep: true,
      inmediate: true,
    },
  },
  methods: {
    ...mapActions({
      fetchList: 'categories/fetchList',
      categoryRoot: 'categories/categoryRoot',
    }),
    async init() {
      this.loading = true
      this.open = []
      this.active = []
      this.categoryTree = []
      let list = await this.fetchList({
        only: 1,
        limit: 0,
        children: true,
        set: false,
      }).finally(() => {
        this.loading = false
      })

      if (!list || !Array.isArray(list)) return
      // this.$nextTick(_ => {
      list.forEach((item) =>
        this.categoryTree.push({
          ...item,
          id: item._id,
          children: item.children ? [] : undefined,
        })
      )

      this.setRoot()
      // })
    },

    async submit(categoryId) {
      try {
        this.$emit('input', categoryId)
        if (categoryId && this.objects) {
          if (!this.objects.some((item) => item.value === categoryId)) {
            this.loading_object = categoryId
            const { data } = await apiAxios.post('categories/select', {
              _id: categoryId,
            })
            if (data.data.category) {
              const { text, parent1, parent2 } = data.data.category[0]
              const name = [parent2, parent1, text].filter((v) => v)
              this.$emit('changeObjects', [
                ...this.objects,
                { value: categoryId, text: name.join(' - ') },
              ])
            }
          }
        }
        this.close()
      } finally {
        this.loadingChildren = ''
      }
    },
    close() {
      this.$refs.menu.save()
      this.$nextTick(() => {
        this.categoryTree = []
        this.open = []
        this.active = []
      })
    },
    async fetchChildren(item) {
      this.loadingChildren = item.id
      let { data } = await apiAxios
        .post(
          'categories/format',
          { parentCategory: item.id, children: true },
          { params: { limit: 0 } }
        )
        .finally(() => {
          this.loadingChildren = ''
        })
      if (
        data.data &&
        data.data.category &&
        Array.isArray(data.data.category)
      ) {
        item.children = data.data.category.map((element) => {
          let result = {
            ...element,
            id: element._id,
          }
          if (element.children) result.children = []
          return result
        })
      } else delete item.children
    },
    async setRoot() {
      if (!this.$attrs.value) return
      this.loadingChildren = this.$attrs.value
      let root = await this.categoryRoot(this.$attrs.value).finally(() => {
        this.loadingChildren = ''
      })
      let open = root.slice(0, root.length - 1)
      if (open.length) {
        let rootItem = this.categoryTree.find(
          (category) => category.id === open[0]
        )
        if (rootItem) {
          this.loadingChildren = this.$attrs.value
          await this.fetchChildren(rootItem).finally(() => {
            this.loadingChildren = ''
          })
          this.open.push(rootItem.id)
          for (const categoryId of open.slice(1, open.length)) {
            this.scrollIntoView(categoryId)
            if (rootItem.children && Array.isArray(rootItem.children)) {
              rootItem = rootItem.children.find(
                (category) => category.id === categoryId
              )
              if (rootItem) {
                await this.fetchChildren(rootItem)
                this.open.push(rootItem.id)
              }
            }
          }
          this.active = root.slice(root.length - 1, root.length)
          this.scrollIntoView(this.$attrs.value)
        }
      }
    },
    fetchCategories: debounce(async function (filters) {
      const { data } = await apiAxios.post('categories/select', filters)
      this.categorySelectList =
        data.data && data.data.category ? data.data.category : []
    }, 700),
    scrollIntoView(ref) {
      this.$nextTick(() => {
        let vm = this
        setTimeout(() => {
          let item = vm.$refs[ref]
          if (item) {
            item.$el.scrollIntoView({
              block: 'end',
              behavior: 'smooth',
            })
          }
        }, 200)
      })
    },
  },
}
</script>
<style lang="scss">
.v-treeview-node__label {
  font-size: 1rem;
  margin-left: 6px;
  flex-grow: 1;
  flex-shrink: 0;
}
</style>
